import React from 'react'
import { store } from '../../store'
import {Grid, Row, Col, Button, FormControl} from 'react-bootstrap'
import Rolling from '../../Images/rolling.svg';

const initialState = {
  user: {
  name: '',
  email: '',
  username: '',
  password: '',
  confirmPassword: ''
},
  error: false,
  missmatch: false,
  status: '',
  userData: null,
  token: null,
  imageUploaded: false,
  flag: false
}
class Register extends React.Component {
  constructor(props) {
    super();
    this.state = initialState
  }
_handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onSubmitSignIn()
    }
  }
onSubmitSignIn = () => {
  this.setState({status: 'processing'})
  let {website, about, customization, activities, links} = store.getState()
  let {name, email, password, confirmPassword, error, username, token} = this.state
  if(!password || !email || !username || !confirmPassword || !name)
  {
    this.setState({error: 'empty'})
    this.setState({status: ''})
    return;
  }
  if(password === confirmPassword && !error)
  {
    fetch(`${process.env.REACT_APP_API}/register`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      user: {
        name: name,
        username: username,
        email: email,
        password: password
        }
      })
    })
    .then(response => response.json())
    .then(register => {
      if (register.auth)
      {
          this.setState({userData: register.user})
          this.props.onUser(register.user)
          this.setState({ token: register.token })
          token = register.token
          this.props.onToken(token)
          if(store.getState().imagesPreview.length !== 0)
          {
              const data = new FormData()
              let arr = store.getState().imagesPreview
              arr.forEach((item, i) =>
              {
                data.append(`file${[i]}`, item.file)
                data.append(`alt_name${[i]}`, item.alt_name)
                data.append(`img_url${[i]}`, item.img_url)
              })
              data.append('url', website.url)
              data.append('username', username)
              data.append('token', register.token)

              fetch(`${process.env.REACT_APP_API}/upload`, {
                method: 'post',
                body: data
              })
              .then((response) =>
              {
                if(response.status !== 404 && response.status !== 500)
                {
                  response.json()
                  .then((body) => 
                  {
                    this.props.onImagesAction(body.images)
                  })
                  .then(()=>this.createWebsite({website, username, register, about, links, customization}))
                }
                else
                {
                  this.createWebsite({website, username, register, about, links, customization})
                }
              })
          }
          else
          {
              this.createWebsite({website, username, register, about, links, customization})
          }
      }
      else
      {
        this.setState({error: true})
      }  
    })
  }
  else if(this.state.error) {
    this.setState({status: ''})
  }
  else {
    this.setState({missmatch: true})
    this.setState({status: ''})
  }
}
createWebsite = ({website, username, register, about, links, customization}) => {
    let bioData = () =>
    {
      if(website.bio)
      {
        return website.bio
      }
      else
      {
        return null
      }
    }
    fetch(`${process.env.REACT_APP_API}/create`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
      user: {
        username: username
      },
      token: register.token,
      website: {
        name: website.name,
        url: website.url,
        template: website.template,
        bio: bioData()
      },
      about: {
        content: about.content,
        rawcontent: about.rawcontent
      },
      links: links,
      customization: customization.custom
      })
    })
    .then((response)=> response.json())
    .then((data)=>{
    if(data.website)
    {
      this.props.onWebsite([website])
      this.props.onSignin('true')
      this.setState({status: 'success'})
    }
    else console.log("Something went wrong!")
    })
}
insertData = (e, username, email) => {
  let bodyData = null
  let userkey = ''
  let emailkey = ''
  if(username && username === 'username')
  { this.setState({
    username: e.target.value.toLowerCase().replace(/\s/gi,"")
  })
    bodyData = {
      username: e.target.value.toLowerCase().replace(/\s/gi,"")
     }
  }
  else
  {
    this.setState({
      email: e.target.value.toLowerCase().replace(/\s/gi,"")
    })
    bodyData = {
      email: e.target.value.toLowerCase().replace(/\s/gi,"")
     }
  }
  if(bodyData.username ? userkey !== this.state.username : bodyData.email ? emailkey !== this.state.email : false)
  {
  fetch(`${process.env.REACT_APP_API}/valid`, {
      method: 'post',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(bodyData)
    })
  .then(response => {
    response.json()
    .then(data => {
      if(data.username) {
      if(data.username === "USERNAME_EXISTS") {
        if(this.state.error === 'email_exists' || this.state.error === 'username_email_exists')  {
        this.setState({error: "username_email_exists"})
        }
        else
        this.setState({error: "username_exists"})
      }
      else {
        userkey = data.username
        if(this.state.error === 'username_email_exists' || this.state.error === 'email_exists')  {
          this.setState({error: "email_exists"})
        }
        else {
          this.setState({error: false})
        }
      }
      }
      if(data.email) {
      if(data.email && data.email === "EMAIL_EXISTS") {
        if(this.state.error === 'username_exists' || this.state.error === 'username_email_exists')  {
        this.setState({error: "username_email_exists"})
        }
        else
        this.setState({
            error: "email_exists"
          })
      }
      else {
        emailkey = data.email
        if(this.state.error === 'username_email_exists' || this.state.error === 'username_exists')  {
          this.setState({
            error: "username_exists"
          })
        }
        else {
          this.setState({
            error: false,
          })
        }
      }
      }
    })
  })
  this.setState({status: ''})
  }
}
checkpasswords = () => {
  if(this.state.password !== this.state.confirmPassword)
  {
    this.setState({missmatch: true})
  }
}
onSuccess = () => {
  window.location = '/'
}
    render() {
      console.log(this.state)
      return (
        <div 
            onKeyDown={this._handleKeyPress}>
          <Grid fluid={true} className="form_bg">
          <Row className="form form_inside">
          <Col lg={6} md={8} sm={12} xs={12} className="form_inside_main">
          <div className="form_in_main reg_inside">
          <span onClick={(route)=>this.props.onRouteChange('url')} href='#' className="go_back go_back_b"/>
          <h3 className="temp_headings black_color">Sign up</h3>
          <br/>
          {this.state.error
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Check everything is correct</span></div><br /></div>
            : null
          }
          {this.state.error === 'empty'
            ? <div><div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>You must fill all columns</span></div><br /></div>
            : null
          }
          <FormControl
            className={
              this.state.error === 'name'
              ? 'form_inp redd'
              : 'form_inp'
            } 
            type="text" 
            name="name" 
            placeholder="Name"
            size="6"
            onChange={(e)=> {
              if(this.state.error === 'name' || this.state.error === 'empty') {
                this.setState({error: ''})
              }
              this.setState({name: e.target.value})}
            }
          />
          {this.state.error === 'name'
            ? <div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Type your Name</span></div>
            : null
          }
          <br/>
          <FormControl
            autocomplete="off"  
            className={
              (this.state.error === 'username_exists' ||
              this.state.error === 'username_email_exists')
              ? 'form_inp redd'
              : 'form_inp'
            } 
            type="text" 
            name="username" 
            placeholder="Username"
            autoCapitalize="off"
            autoCorrect="off"
            size="6"
            onChange={(e, username)=>this.insertData(e, 'username')}
          />
          {(this.state.error === 'username_exists' ||
              this.state.error === 'username_email_exists')
            ? <div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>This username is taken</span></div>
            : null
          }
          <br/>
          <FormControl  
            autocomplete="off" 
            className={
              (this.state.error === 'email_exists' ||
              this.state.error === 'username_email_exists')
              ? 'form_inp redd'
              : 'form_inp'
            }  
            type="email" 
            name="email" 
            placeholder="Email"
            autoCapitalize="off"
            autoCorrect="off"
            size="6"
            onChange={(e, email)=>this.insertData(e, 'email')}
          />
          {(this.state.error === 'email_exists' ||
              this.state.error === 'username_email_exists')
            ? <div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>This email is already in use</span></div>
            : null
          }
          <br/>
          <FormControl  
            className={
              this.state.missmatch
              ? 'form_inp redd'
              : 'form_inp'
            } 
            type="password" 
            name="password" 
            placeholder="Password"
            onFocus={()=>this.setState({missmatch: false})} 
            onChange={(e)=>this.setState({password: e.target.value})} 
          />
          <br/>
          <FormControl  
            className={
              this.state.missmatch
              ? 'form_inp redd'
              : 'form_inp'
            } 
            type="password" 
            name="confirm password" 
            placeholder="Confirm Password"
            onFocus={()=>this.setState({missmatch: false})} 
            onChange={(e)=>this.setState({confirmPassword: e.target.value})}
            onBlur={this.checkpasswords.bind()} 
          />
          {this.state.missmatch
            ? <div className="reg_error"><span><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Please enter your passwords correctly</span></div>
            : null
          }
          <br /><br />
          <Button onClick={this.onSubmitSignIn.bind()} className="btn_new form_btn">
          {
          this.state.status === 'processing'
              ? <span className="rolling"><img src={Rolling} className="rolling_img" alt="rolling"/></span>
              : null
          }
          {
          this.state.status === 'success'
              ? this.onSuccess()
              : null
          }
          {
          !this.state.status
              ? <span>Register</span>
              : null
          }
          </Button>
          </div>
          </Col>
          <Col lg={6} md={8} sm={0} xs={0}>
          <div className="form_inside_img">
          <img className="form_inside_img_src" src='/assets/img/reg_image.svg' alt="signin_side_img"/>
          </div>
          </Col>
          </Row>
          </Grid>

      </div>
      );
    }
}
export default Register;